<div class="grid mt-0 px-3" [formGroup]="filterGroup">
	<div [class]="col4Responsive()">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
			[ngClass]="simpleInputTextLayout('borderRow')">
			<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
				'SELECT_DEVICE' | translate }}</div>
			<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('borderInput')">
				<p-dropdown [options]="devices" formControlName="deviceId" [ngClass]="dynamicInputTextWidth()"
					[filter]="true" [filterBy]="'Name'" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900"
					id="events-input-deviceFilter" placeholder="{{ 'SELECT_DEVICE' | translate }}"
					(onChange)="onSelectDeviceId()">
					<ng-template let-item pTemplate="selectedItem">
						<div class="item" class="flex align-items-center justify-content-center">
							<div class="flex justify-content-center">{{ item.Name | truncate:[26] }}</div>
						</div>
					</ng-template>
					<ng-template let-item pTemplate="item">
						<div class="item flex align-items-center justify-content-center">
							<div>{{ item.Name | truncate:[26] }}</div>
						</div>
					</ng-template>
				</p-dropdown>
			</div>
		</div>
	</div>
	<div [class]="col4Responsive()">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
			[ngClass]="simpleInputTextLayout('borderRow')">
			<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
				'SELECT_EVENT' | translate }}</div>
			<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('borderInput')">
				<p-dropdown [options]="eventTypes" formControlName="typeId" [ngClass]="dynamicInputTextWidth()"
					[filter]="true" [filterBy]="'DescriptionLabel'" appendTo="body"
					styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900" id="events-input-deviceFilter"
					placeholder="{{ 'SELECT_EVENT' | translate }}" (onChange)="onSelectTypes()">
					<ng-template let-item pTemplate="selectedItem">
						<div class="item" class="flex align-items-center justify-content-center">
							<div class="flex justify-content-center">{{ item.DescriptionLabel | truncate:[26] }}</div>
						</div>
					</ng-template>
					<ng-template let-item pTemplate="item">
						<div class="item flex align-items-center justify-content-center">
							<div *ngIf="!onExtendedMobile()" class="flex justify-content-center w-23rem">{{ item.DescriptionLabel | truncate:[45] }}</div>
							<div *ngIf="onExtendedMobile()" class="flex justify-content-center">{{ item.DescriptionLabel | truncate:[26] }}</div>
						</div>
					</ng-template>
				</p-dropdown>
			</div>
		</div>
	</div>
	<div [class]="col4Responsive()">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
			[ngClass]="simpleInputTextLayout('borderRow')">
			<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
				'ENTER_DATE_RANGE' | translate }}</div>
			<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('borderInput')">
				<p-calendar [showIcon]="true" formControlName="picker" selectionMode="range" [showButtonBar]="true"
					placeholder="{{'ENTER_DATE_RANGE' | translate}}" id="events-input-deviceFilter"
					[class]="dynamicInputTextWidth()" [styleClass]="dynamicInputTextWidth()"
					inputStyleClass="pl-6 sm:pl-5 border-noround-right surface-900" [minDate]="minDate" [maxDate]="today"
					[defaultDate]="today" (onSelect)="onSelectPicker()">
				</p-calendar>
			</div>
		</div>
	</div>
	<div [class]="buttonRespCol()">
		<p-button id="buttonExportEvents" label="{{ 'EXPORT' | translate }}" icon="pi cm-download" (click)="exportToCsv()"
			[rounded]="false" [text]="true" severity="primary" [disabled]="totalRecords <= 0"
			styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-18rem">
		</p-button>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()" *ngIf="rejectButtonVisible">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>
